import WeekHeader from './week-header';

export default WeekHeader;
